import _ from 'lodash';
import { observable, action } from 'mobx';

export class SettingsStore {
  @observable settings: SettingsInfo.All = {} as any;

  @action
  updateAllSettings(allSettings: SettingsInfo.All) {
    this.settings = allSettings;
  }

  @action
  updateSetting(setting: any) {
    const newSettingKey = Object.keys(setting)[0];
    _.forOwn(this.settings, (subsettings, category) => {
      if (_.has(subsettings, newSettingKey)) {
        _.assign(subsettings, setting);
      }
    });
    /*
        if (!this.settings) {
            this.settings = {} as any
        }
        if (_.has(whichever, "changedStatus")) {
            if (whichever.changedStatus) {
                let toChange = _.omit(whichever, ["changedStatus"])
                _.assign(this.settings, toChange)
            }
        }
        else {
            _.assign(this.settings, whichever)
            console.log(this.settings)
        }
        console.log("Setting updated: "+JSON.stringify(whichever))
        */
  }
}

export const settingsStore = new SettingsStore();
